import apiClient from './api.service';
import {
  AdminTag,
  AdminTagListResponse,
  CreateAdminTagPayload,
  UpdateAdminTagPayload,
} from '../types/tag.types';

class TagService {
  async listAdminTags(): Promise<AdminTag[]> {
    const response = await apiClient.get<{ data: AdminTagListResponse }>('/api/admin/tags');
    return response.data.data.items;
  }

  async createAdminTag(payload: CreateAdminTagPayload): Promise<AdminTag> {
    const response = await apiClient.post<{ data: AdminTag }>('/api/admin/tags', payload);
    return response.data.data;
  }

  async updateAdminTag(tagId: string, payload: UpdateAdminTagPayload): Promise<AdminTag> {
    const response = await apiClient.patch<{ data: AdminTag }>(`/api/admin/tags/${tagId}`, payload);
    return response.data.data;
  }

  async reactivateAdminTag(tagId: string): Promise<AdminTag> {
    const response = await apiClient.post<{ data: AdminTag }>(`/api/admin/tags/${tagId}/reactivate`);
    return response.data.data;
  }
}

export const tagService = new TagService();
